/**
 * Antares detector mark — inline SVG styled to match the platform's cosmic
 * palette. Antares is a red supergiant in Scorpio, so a subtle star motif
 * fits both the detector's name and the "orbit / nebula / aurora" naming
 * already in the design system.
 */
export const AntaresMark: React.FC<{ size?: number }> = ({ size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <defs>
      <linearGradient id="antares-mark-grad" x1="0" y1="0" x2="24" y2="24" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#F55A4F" />
        <stop offset="55%" stopColor="#FF006C" />
        <stop offset="100%" stopColor="#C935FF" />
      </linearGradient>
    </defs>
    <circle cx="12" cy="12" r="9" stroke="url(#antares-mark-grad)" strokeWidth="1.5" opacity="0.45" />
    <path
      d="M12 3.5 L13.6 10.4 L20.5 12 L13.6 13.6 L12 20.5 L10.4 13.6 L3.5 12 L10.4 10.4 Z"
      fill="url(#antares-mark-grad)"
    />
  </svg>
)
